export default "{\n    \"label\": \"Escalation\",\n    \"options\": {\n        \"true\": \"Currently escalated\"\n    }\n}\n"